// import style from "./modal.module.css"
import React, { useRef, useState } from "react";
import ComponentTitle from "../ProductCondition/ComponentTitle";
import YearPicker from "../YearPicker";
import { PkcdxxDropbox, BsswghDropbox } from "../ProductCondition/Dropbox";
import DropboxLabel from "../ProductCondition/DropboxLabel";
import Button from "../ProductCondition/Button";
import { useLocation } from "react-router-dom";
import DateRangePicker from "../ProductCondition/DateRangePicker";
import MonthRagePicker from "./MonthRangePicker";

const SearchState = ({requestData, setRequestData, onclick}) => {
  const location = useLocation();
  return (
    <div>
      <div className="flex border-t border-b border-gray-400 py-2">
        <ComponentTitle title={"☞ 조회조건"}/>      
        <div className="flex lg:max-w-72 md:max-w-28 mx-7">
          <DropboxLabel searchCategory={location.pathname === "/month" ? "년도" : "년월"}/>
          {
            location.pathname === '/month' 
            ?
              <YearPicker setRequestData={setRequestData}/> 
            :
              <MonthRagePicker requestData={requestData} setRequestData={setRequestData} />
          }
          
        </div>
        <div className="flex mx-7">
          <DropboxLabel searchCategory={"지종"} />
          <PkcdxxDropbox data={requestData} setData={setRequestData}/>
        </div>
        <div className="flex mx-7">
          <DropboxLabel searchCategory={"평량"} />
          <BsswghDropbox data={requestData} setData={setRequestData}/>
        </div>
        <Button buttonText={"조회F12"} buttonAction={onclick}/>
      </div>
      <div>
      {/* <button onClick={handleModal} type="button" className="max-h-6 text-blue-700 border border-black bg-gradient-to-t from-gray-400 to-white hover:bg-gradient-to-br font-bold px-2.5 me-2" >모달오픈</button> */}
      {/* <ReactToPrint 
        trigger={() => (
          <button className="close" onClick={handleModal}>
            인쇄
          </button>    
        )}
        content={() => ref.current}
        onAfterPrint={() => handleModal()}
      />
      <div ref={ref} className="px-1 invisible">
            <div className="p-12">
              <Print />
            </div>
          </div>
      <Modal modal={modal} handleModal={handleModal}/> */}
      </div>
    </div>
  )
}

export default SearchState;